import React from "react";
import * as C from "./ErrorPopup.styles.js";

const ErrorPopup = ({ isOpen, message, onClose }) => {
	if (!isOpen) return null;

	return (
		<C.ErrorBackground>
			<C.ErrorContainer>
				<C.ErrorMessage>{message}</C.ErrorMessage>
				<C.CloseButton onClick={onClose}>Fechar</C.CloseButton>
			</C.ErrorContainer>
		</C.ErrorBackground>
	);
};

export default ErrorPopup;